// Which features need the paid tier. Change the free/paid split here only.
export const PRO_FEATURES = {
  spendDownAdvanced: {
    title: 'Advanced Spend-Down Planning',
    description: 'What-ifs like a death, a pension lump sum or an annuity, where each year\'s money comes from, the withdrawal plan search, yearly income and tax, required distributions, and Roth and Social Security comparisons.',
  },
  strategyDetail: {
    title: 'Method Detail and Tuning',
    description: 'Follow any withdrawal method year by year through weak, middle and strong markets, and change its rules.',
  },
  planTracking: {
    title: 'Tracking Against a Baseline',
    description: 'Save where your plan stands today. Come back after a market drop, a raise or a year, and see how your savings compare with what the plan expected.',
  },
  multiplePlans: {
    title: 'Multiple Plans',
    description: 'Keep several plans and compare them side by side. Retire at 58 or 62, one income or two, before or after a move.',
  },
  advancedRetirement: {
    title: 'Retirement Age Explorer',
    description: 'See how often your plan holds up at every retirement age and spending level, and copy any one into your plan.',
  },
  reportExport: {
    title: 'Report Export',
    description: 'Download your plan as a PDF report, Excel workbook, or CSV.',
  },
  excelCalculator: {
    title: 'Excel Plan Calculator',
    description: 'An Excel workbook with live formulas. Change an input and the yearly projection updates, no app needed.',
  },
  propertyComparison: {
    title: 'Multi-Property Comparison',
    description: 'Rank several properties on yearly return, cash flow and profit.',
  },
  cloudSync: {
    title: 'Cloud Sync',
    description: 'Your plan, backed up and in sync on all your devices.',
  },
};

// What every user has without paying. Shown beside the Pro list on the Free
// and Pro page; keep it in step with where ProGate is used.
export const FREE_FEATURES = [
  { title: 'Financial Profile', description: 'Your ages, accounts, pay, savings, Social Security and pensions, saved on your device.' },
  { title: 'Monte Carlo growth simulation', description: 'How your savings could grow until retirement across thousands of simulated markets.' },
  { title: 'Spend-Down results', description: 'How often your retirement spending holds up after income tax, with all seven withdrawal methods compared.' },
  { title: 'The history test', description: 'Your plan run from every starting year since 1928, through the markets that followed.' },
  { title: 'State tax and other details', description: 'State tax, health coverage before Medicare, other income, one-off money, a mortgage, care, and money to leave behind.' },
  { title: 'Compare Plans', description: 'Saved plans side by side, through the same simulated markets. Keeping more than one plan is part of Pro.' },
  { title: 'Your withdrawal plan', description: 'Withdrawal order, Roth conversions and 72(t) payments, free or Pro.' },
  { title: 'Plain explanations and the help assistant', description: 'What each method and choice means, without the jargon.' },
  { title: 'Real estate analysis for one property', description: 'Flip, long-term rental and short-term rental, compared over the same five years, with priority scoring and sliders. You can add a rental to your retirement plan as income.' },
  { title: 'One plan, and a free account', description: 'Signing in is free and optional. Without Pro, your plan stays on the device you use.' },
];

// Web billing through Stripe. Off unless the build sets REACT_APP_WEB_BILLING=on,
// so the website stays fully open until checkout has been set up and tested.
// App Store 1.0 ships free-only (Jason lock via Fulcrum, 2026-10-30). Pro in-app purchase arrives in 1.1:
// set this to true for the 1.1 build. While false, the iOS app sells nothing and locks nothing.
export const IOS_STORE_BILLING_ON = false;

export const WEB_BILLING_ON = process.env.REACT_APP_WEB_BILLING === 'on';

// What the website offers. The amounts charged are the Stripe prices the
// server is configured with (docs/STRIPE_SETUP.md); keep these labels in step.
export const WEB_PLANS = [
  { id: 'annual', title: 'Annual', price: '$29.99', period: 'per year', trial: '7-day free trial, then ', best: true },
  { id: 'monthly', title: 'Monthly', price: '$4.99', period: 'per month' },
  { id: 'lifetime', title: 'Lifetime', price: '$79.99', period: 'one-time' },
];

// Entitlement identifier configured in the RevenueCat dashboard.
export const PRO_ENTITLEMENT_ID = 'pro';

export const REVENUECAT_KEYS = {
  ios: process.env.REACT_APP_REVENUECAT_IOS_KEY || '',
  android: process.env.REACT_APP_REVENUECAT_ANDROID_KEY || '',
};
